<i18n src="@/i18n/components/search/filter.json"></i18n>
<template>
  <div class="filter-business-event-attribute-field">
    <FilterBaseInputText
      v-model="value"
      :prefix="$t('containsPrefix')"
      :suffix="$te('containsSuffix') ? $t('containsSuffix') : ''"
    />
  </div>
</template>

<script lang="ts">
import { Component, Model, Vue } from "vue-property-decorator";
import { FilterBusinessEventAttributeCondition } from "@/models/search/filter-node-condition/FilterBusinessEventAttributeCondition";

import FilterBaseInputText from "@/components/filter/form/FilterBaseInputText.vue";

@Component({
  components: {
    FilterBaseInputText
  }
})
export default class FilterBusinessEventAttributeField extends Vue {
  @Model("input", {
    type: FilterBusinessEventAttributeCondition,
    required: true
  })
  condition!: FilterBusinessEventAttributeCondition;

  onInput(condition: FilterBusinessEventAttributeCondition) {
    this.$emit("input", condition);
  }

  get value(): string {
    return this.condition.content;
  }
  set value(value: string) {
    this.onInput(new FilterBusinessEventAttributeCondition(value));
  }
}
</script>
<style lang="scss" scoped>
.filter-business-event-attribute-field {
  display: flex;
  align-items: center;
}

.select-box {
  margin-right: 7px;
}
</style>
